import * as React from "react";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { IDraftWorkSearchQuery } from "../types/IDraftWorkSearchQuery";
import { useMsal } from "@azure/msal-react";
import { ComponentsHelper } from "../../core/services/ComponentHelper";
import { IDraftWorkSearchResult } from "../types/IDraftWorkSearchResult";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { IMemberWorkSearchResult } from "../types/IMemberWorkSearchResult";
import { MemberPortalSearchTypeItem } from "../../redux/types/MemberPortalSearchTypeItem";
import { MemberPortalSearchType } from "../../redux/types/MemberPortalSearchType";
import { SearchRequests } from "../../repertoire/services/SearchRequests";
import { CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP } from "../ConfigurationConsts";
import { FormatFields } from "../../redux/types/FormatFields";
import { IMyPackagesResult } from "../../repertoire/types/IMyPackagesResult";
import DraftWorksSearchView from "../draftWorks/DraftWorksSearchView";
import MemberWorksSearchView from "./MemberWorksSearchView";
import { DataSource } from "../../repertoire/types/DataSource";
import { setDataSource } from "../../redux/reducers/MembersPortalReducer";
import { IRegisteredWorkSearchQuery } from "../types/IRegisteredWorkSearchQuery";
import { PERMISSION_MESSAGE } from "../../repertoire/Consts";
import ITooltip from "../../repertoire/components/Tooltip/IToolTip";
import { MembersPortalRoles } from "../../redux/types/MembersPortalRoles";
import { MembersPortalService } from "../../redux/services/MembersPortalService";
import { IAssigneeAgreementResult } from "../types/IAssigneeAgreementResult";
import { hideModal, showYesNoPrompt } from "../../redux/reducers/ModalReducer";
import InfoToggle from "../sharedComponents/button/InfoToggle";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";
import { AddToPackageProvider } from "../sharedComponents/button/AddToPackageContext";


export interface IMemberWorksPageProps {
    memberWorksPageData: IMembersPortalComponentDataItem;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    searchDraftWorks?: (query: IRegisteredWorkSearchQuery) => void;
    memberWorkSearchResults?: IMemberWorkSearchResult[];
    searchSuccessful: boolean;
    memberWorksMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
    lookupValues: ILookupDictionary;
    loadMembersPortalFromPath?: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    getMemberWorkDetails: (dataSource: string, workID: number, lookupValues: ILookupDictionary, memberWorkMaintenanceDataViewData: IMembersPortalComponentDataItem, formats?: FormatFields[], includeAllMyAccounts?: boolean) => void;
    addNewDraftWorks: (lookups: ILookupDictionary, currentUserNameNumber?: string, isNew?: boolean, memberWorksMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    disabled?: boolean;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    setDataSource: typeof setDataSource;
    dataSource: string;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    memberPortalSearchType: MemberPortalSearchTypeItem;
    currentUserNameNumber?: string;
    expandWorkResult?: (workResult: number) => void;
    expandedWorkResults?: number[];
    expandAllResults: () => void;
    expandAll: boolean;
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => IMyPackagesResult;
    componentInstance: string;
    customer?: string;
    getAssigneeAgreements?: () => void;
    assigneeAgreementsResult?: IAssigneeAgreementResult[];
    hideModal?: typeof hideModal;
    showYesNoPrompt?: typeof showYesNoPrompt;
    fullCataloguePackagePending?: boolean;
    saveInProgress?: boolean;
    packageGenerationMessage?: string;
    packageOperationInProgress?: boolean;
    packageItemIds?: number[];
    createPackageFromCriteria?: (userName: string, criteria: IRegisteredWorkSearchQuery) => void;
}

const MemberWorksPage: React.FC<IMemberWorksPageProps> = (props: IMemberWorksPageProps) => {
    const [loaded, setLoaded] = React.useState(false);
    const { instance, accounts } = useMsal();

    React.useEffect(() => {
        checkIfLoaded();

        const account = accounts[0]
        ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
    }, [props, loaded])


    const checkIfLoaded = () => {
        const { memberWorksPageData } = props;

        if (memberWorksPageData.fields && memberWorksPageData.fields.length >= 1 && !loaded) {
            setLoaded(true);
            const header = memberWorksPageData.fields.find(f => f.name === "PageTitle");
            if (header) {
                document.title = header.data;
            }
        }
    }
    const addNewDraftWorks = (): void => {
        const { addNewDraftWorks, lookupValues, memberWorksMaintenanceGeneralDataViewData, currentUserNameNumber } = props;
        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
            .then(formats => {
                addNewDraftWorks(lookupValues, currentUserNameNumber, true, memberWorksMaintenanceGeneralDataViewData, formats);
            });
    }

    

    if (loaded) {
        const {
            memberWorksPageData,
            memberWorksMaintenanceGeneralDataViewData,
            searchViewData,
            searchResultsTableData,
            searchDraftWorks,
            searchSuccessful,
            indexOfFirstResult,
            indexOfLastResult,
            resultsPerPage,
            currentPage,
            resetPagination,
            updatePagination,
            sortSearchResults,
            lookupValues,
            expandAllResults,
            expandAll,
            currentUserNameNumber,
            loadMembersPortalFromPath,
            memberPortalSearchType,
            tabs,
            activeTab,
            dataSource,
            componentInstance,
            customer,
            addToPackages,
            getAssigneeAgreements,
            showYesNoPrompt,
            hideModal,
            fullCataloguePackagePending,
            createPackageFromCriteria,
            saveInProgress,
            packageGenerationMessage,
            packageOperationInProgress,
            packageItemIds,
        } = props;

        let currentDataSource = dataSource;

        const getMemberWorkDetails = (dataSource: string, workID: number, includeAllMyAccounts?: boolean) => {
            SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
                .then(formats => {
                    props.getMemberWorkDetails(dataSource, workID, lookupValues, memberWorksMaintenanceGeneralDataViewData, formats, includeAllMyAccounts);
                });
        }

        let searchPageLabelTitle = null;
        if (memberWorksPageData && memberWorksPageData.fields.length > 0) {
            searchPageLabelTitle = memberWorksPageData.fields.find((v, i, a) => v.name == "searchPageLabelTitle").data;
        }

        let searchResults = null

        searchResults = props.memberWorkSearchResults;

        const hasPermission = MembersPortalService.hasPermissionForMenu("registerNewWork", MembersPortalRoles.FullAccess);

        const infoToggleHeaderField = memberWorksPageData.fields
            .find(x => x.name === 'infoToggleHeader');

        const infoToggleHtmlField = memberWorksPageData.fields
            .find(x => x.name === 'infoToggleHTML');


        const renderInfoToggle = (
            <InfoToggle
                headerTextItem={infoToggleHeaderField}
                htmlTextItem={infoToggleHtmlField}
                currentUserNameNumber={currentUserNameNumber}
                lookupValues={lookupValues}
                loadMembersPortalFromPath={loadMembersPortalFromPath}
            />
        );

        return (
            <div>
                <div className="row">
                    <div id="me-title" className="col-md-12">
                        <span className="title">{searchPageLabelTitle}</span>
                        {hasPermission ? (
                            <div className="newWorkButton" title="Register New Work">
                                <div className="IconTextButton" onClick={addNewDraftWorks}>
                                    <i
                                        className="icon ms-Icon ms-Icon--CircleAddition"
                                        aria-hidden="true"
                                    ></i>
                                    {memberWorksPageData.fields.find(v => v.name === "registerNewWork")?.data}
                                </div>
                            </div>
                        ) : (
                            <div className="newWorkButton" title="Register New Work">
                                <ITooltip
                                    tooltipContent={PERMISSION_MESSAGE}
                                    showTooltip={true}
                                    placement="top"
                                >
                                    <span style={{ display: 'inline-block' }}>
                                        <div className="IconTextButton disabled">
                                            <i
                                                className="icon ms-Icon ms-Icon--CircleAddition disabled"
                                                aria-hidden="true"
                                            ></i>
                                            {memberWorksPageData.fields.find(v => v.name === "registerNewWork")?.data}
                                        </div>
                                    </span>
                                </ITooltip>
                            </div>
                        )}
                    </div>
                </div>
                {renderInfoToggle }
                <AddToPackageProvider
                    packageGenerationMessage={packageGenerationMessage}
                    packageOperationInProgress={packageOperationInProgress}
                    packageItemIds={packageItemIds}
                >
                    <MemberWorksSearchView
                        searchViewData={searchViewData}
                        searchResultsTableData={searchResultsTableData}
                        lookupValues={lookupValues}
                        searchMemberWorks={searchDraftWorks}
                        memberWorkSearchResults={searchResults}
                        searchSuccessful={searchSuccessful}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        currentPage={currentPage}
                        resetPagination={resetPagination}
                        updatePagination={updatePagination}
                        sortSearchResults={sortSearchResults}
                        expandAllResults={expandAllResults}
                        expandAll={expandAll}
                        currentUserNameNumber={currentUserNameNumber}
                        getMemberWorkDetails={getMemberWorkDetails}
                        memberPortalSearchType={memberPortalSearchType}
                        dataSource={currentDataSource}
                        tabs={tabs}
                        activeTab={activeTab}
                        componentInstance={componentInstance}
                        customer={customer}
                        addToPackages={addToPackages}
                        getAssigneeAgreements={getAssigneeAgreements}
                        assigneeAgreementsResult={props.assigneeAgreementsResult}
                        hideModal={hideModal}
                        showYesNoPrompt={showYesNoPrompt}
                        fullCataloguePackagePending={fullCataloguePackagePending}
                        createPackageFromCriteria={createPackageFromCriteria}
                        saveInProgress={saveInProgress}
                    />
                </AddToPackageProvider>
            </div>
        );
    }
    return <div>Loading...</div>
}

export default MemberWorksPage;
